import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getShotClassUserReport = (
  fromDate,
  pageNumber,
  pageSize,
  reportMode,
  classId,
  toDate,
  trainingType
) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  if (reportMode === "View") {
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.TABULAR_REPORT.SHOTCLASS_USER_REPORT(
        fromDate,
        pageNumber,
        pageSize,
        reportMode,
        classId,
        toDate,
        trainingType
      ),
      "",
      cancelToken
    );
  } else {
    let url =
      encodeURIComponent(apiConstants.BASE_URL_1) +
      encodeURIComponent(
        apiConstants.REPORT.TABULAR_REPORT.SHOTCLASS_USER_REPORT(
          fromDate,
          pageNumber,
          pageSize,
          reportMode,
          classId,
          toDate,
          trainingType
        )
      );
    let template = "ShotClassUserReport";
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.CSV_REPORT(url, template),
      "",
      cancelToken
    );
  }
};

export default getShotClassUserReport;
